import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import { useAuth } from '../hooks/useAuth';
import { useLang } from '../contexts/langContext';
import { e2eLogin } from '../services/auth';

const sanitizeRedirect = (value: string | null): string => {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return '/projects';
  return value;
};

function E2ELoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();
  const { lang } = useLang();
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const login = async () => {
      try {
        const redirect = sanitizeRedirect(searchParams.get('redirect'));
        const result = await e2eLogin(searchParams.get('email'), redirect);
        if (!active) return;
        setUser(result.user);
        navigate(sanitizeRedirect(result.redirect), { replace: true });
      } catch (requestError) {
        console.error('E2E login failed:', requestError);
        if (active) {
          setError(lang === 'en' ? 'Development E2E login is not available.' : '开发环境 E2E 登录不可用。');
        }
      }
    };

    login();
    return () => {
      active = false;
    };
  }, [lang, navigate, searchParams, setUser]);

  return (
    <AuthLayout title={lang === 'en' ? 'Development Login' : '开发环境登录'}>
      {error ? (
        <Box sx={{ textAlign: 'center' }}>
          <Alert severity="warning" variant="outlined" sx={{ mb: 2 }}>{error}</Alert>
          <Button component={RouterLink} to="/login" variant="contained">
            {lang === 'en' ? 'Go to Login' : '前往登录'}
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3, gap: 2 }}>
          <CircularProgress />
          <Typography color="text.secondary">{lang === 'en' ? 'Signing in with development auth...' : '正在使用开发环境认证登录...'}</Typography>
        </Box>
      )}
    </AuthLayout>
  );
}

export default E2ELoginPage;
